/**
 * Emoji shortcode mappings for autocomplete
 * Format: shortcode -> emoji
 */
export const EMOJI_SHORTCUTS: Record<string, string> = {
  // Smileys & Emotion
  smile: '😀',
  grin: '😃',
  joy: '😂',
  laugh: '🤣',
  happy: '😊',
  love: '😍',
  heart_eyes: '😍',
  kiss: '😘',
  wink: '😉',
  thinking: '🤔',
  cool: '😎',
  sunglasses: '😎',
  nerd: '🤓',
  party: '🥳',
  star_struck: '🤩',

  // Gestures & Body
  thumbsup: '👍',
  thumbs_up: '👍',
  '+1': '👍',
  thumbsdown: '👎',
  thumbs_down: '👎',
  '-1': '👎',
  ok: '👌',
  wave: '👋',
  clap: '👏',
  pray: '🙏',
  handshake: '🤝',
  muscle: '💪',
  point_up: '☝️',
  point_down: '👇',
  point_left: '👈',
  point_right: '👉',

  // Hearts & Love
  heart: '❤️',
  red_heart: '❤️',
  orange_heart: '🧡',
  yellow_heart: '💛',
  green_heart: '💚',
  blue_heart: '💙',
  purple_heart: '💜',
  black_heart: '🖤',
  white_heart: '🤍',
  broken_heart: '💔',
  sparkle: '✨',

  // Reactions
  fire: '🔥',
  rocket: '🚀',
  tada: '🎉',
  party_popper: '🎉',
  confetti: '🎊',
  trophy: '🏆',
  star: '⭐',
  eyes: '👀',
  100: '💯',
  check: '✅',
  checkmark: '✅',
  x: '❌',
  cross: '❌',
  warning: '⚠️',

  // Nature & Food
  sun: '☀️',
  moon: '🌙',
  rainbow: '🌈',
  cloud: '☁️',
  rain: '🌧️',
  snow: '❄️',
  tree: '🌳',
  flower: '🌸',
  rose: '🌹',
  pizza: '🍕',
  burger: '🍔',
  coffee: '☕',
  beer: '🍺',
  wine: '🍷',
  cake: '🎂',

  // Tech & Objects
  computer: '💻',
  laptop: '💻',
  phone: '📱',
  mobile: '📱',
  email: '📧',
  mail: '📧',
  memo: '📝',
  pencil: '✏️',
  book: '📖',
  bulb: '💡',
  light: '💡',
  lock: '🔒',
  unlock: '🔓',
  key: '🔑',
  bell: '🔔',

  // Misc
  question: '❓',
  exclamation: '❗',
  sos: '🆘',
  new: '🆕',
  up: '🆙',
  ok_button: '🆗',
  cool_button: '🆒',
  free: '🆓',
};

/**
 * Search for emoji shortcuts matching the query
 */
export function searchEmojiShortcuts(
  query: string,
  limit = 10
): Array<{ shortcode: string; emoji: string }> {
  const lowerQuery = query.toLowerCase();
  const results: Array<{ shortcode: string; emoji: string }> = [];

  for (const [shortcode, emoji] of Object.entries(EMOJI_SHORTCUTS)) {
    if (shortcode.startsWith(lowerQuery)) {
      results.push({ shortcode, emoji });
      if (results.length >= limit) break;
    }
  }

  // If not enough exact matches, include partial matches
  if (results.length < limit) {
    for (const [shortcode, emoji] of Object.entries(EMOJI_SHORTCUTS)) {
      if (!shortcode.startsWith(lowerQuery) && shortcode.includes(lowerQuery)) {
        results.push({ shortcode, emoji });
        if (results.length >= limit) break;
      }
    }
  }

  return results;
}
